export default {"src":"/_next/static/image/public/images/dropdown.844a2defd35c2d5ae13c9657bcd9b6c7.svg","height":9,"width":11};